import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ModalButton } from 'src/components/Global/Button/Button'
import { BankAccountsWrapper } from './style'
import { getMyBanksDataAction } from 'src/redux/actions/bankAction'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'src/redux/root-reducer'
import { VaultSvg } from 'src/assets'
import { BankDetailsRender } from './BankDetailsRender'
import { useTypedSelector } from 'src/redux'

export const BankAccountsDetail = ({ myBanksData }: any) => {
  const dispatch = useDispatch()
  let location = useLocation()

  const details = useTypedSelector(
    (state) => state.banksResult.getMyBanks?.bank_details
  )

  console.log(details)

  useEffect(() => {
    dispatch(getMyBanksDataAction())
  }, [dispatch])

  const myBanks = details

  return (
    <BankAccountsWrapper>
      <h1 className="title">Bank Accounts</h1>

      <div className="bank_list_wrapper">
        {myBanks && myBanks?.length === 0 ? (
          <div className="vault_container">
            <img src={VaultSvg} alt="" />
            <p>Your bank account section looks empty</p>
          </div>
        ) : (
          <>
            <BankDetailsRender myBanks={myBanks} />
          </>
        )}
      </div>

      <div className="btn-container">
        <Link to={`/bank-setting`} state={{ backgroundLocation: location }}>
          <ModalButton>Add Bank Account</ModalButton>
        </Link>
      </div>
    </BankAccountsWrapper>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    myBanksData: state.banksResult.getMyBanks,
  }
}

export default connect(mapStateToProps)(BankAccountsDetail)
